"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('home', {
            url: '/home',
            template: require('../views/dashboard.html'),
            controller: 'DashboardController',
            controllerAs: 'dashboard',
            resolve: {
                auth: ['auth', function (auth) {
                        return auth.getIdentity();
                    }]
            }
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/config/routes.js
// module id = 477
// module chunks = 0